export const CONTENT_KINDS = ["announcement", "promotion"];
export const CONTENT_STATES = [
    "draft",
    "pending_approval",
    "scheduled",
    "published",
    "paused",
    "expired",
    "archived",
];
/** States that may appear on the public API when schedule-eligible. */
export const PUBLIC_CONTENT_STATES = ["scheduled", "published"];
export const CONTENT_SCOPES = ["global", "site_group", "site"];
export const ANNOUNCEMENT_SEVERITIES = ["info", "maintenance", "warning", "success"];
/** Specificity rank for C3B level-first resolution (higher level wins before priority). */
export const SCOPE_SPECIFICITY = {
    global: 1,
    site_group: 2,
    site: 3,
};
export const CONTENT_LIMITS = {
    titleMax: 120,
    bodyMax: 500,
    badgeMax: 40,
    ctaLabelMax: 60,
    imageAltMax: 120,
};
export const ANNOUNCEMENT_SEVERITY_COLORS = {
    info: "#1A4A6B",
    maintenance: "#B45309",
    warning: "#B91C1C",
    success: "#15803D",
};
//# sourceMappingURL=content.js.map